import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useRef, useState } from "react";

//Hooks
import { useHistory } from "react-router-dom";

// Styles
import defaultClasses from "./banner.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import Icon from "../Icon";
import Image from "../../overrides/venia-ui/components/Image";
import { pushToMiScusi } from "@Components/LinkBetween/miScusiAndTakeAwayUtils";
var Banner = props => {
  var history = useHistory();
  var {
    title,
    subtitle,
    link,
    image,
    icon,
    bgColor,
    bgImage,
    containerClass,
    onClick,
    id,
    isActive = false,
    extraClasses = ""
  } = props;
  var bg = {
    backgroundColor: bgColor || 'transparent',
    // Fallback if bgColor is undefined
    backgroundImage: bgImage ? "linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6)), url(".concat(bgImage, ")") : 'none',
    // Adds a dark gradient overlay on top of the image
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  };
  var classes = mergeClasses(defaultClasses);
  return /*#__PURE__*/React.createElement("div", _extends({}, id && {
    id
  }, {
    className: "uk-flex uk-flex-middle\n            ".concat(extraClasses, "     \n            ").concat(classes.banner, " ").concat(classes['component-banner'], " ").concat(containerClass || '', " ").concat(isActive ? classes.active : '', " "),
    style: bg,
    onClick: onClick ? onClick : link ? () => pushToMiScusi(history.push, link) : null
  }), image ? /*#__PURE__*/React.createElement(Image, {
    src: image,
    alt: title,
    displayPlaceholder: false
  }) : null, icon && !image ? /*#__PURE__*/React.createElement(Icon, {
    className: "uk-padding-small ".concat(classes.Icon, " "),
    name: icon,
    color: "white"
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "content uk-padding-small uk-flex uk-flex-column uk-text-left ".concat(classes.content)
  }, /*#__PURE__*/React.createElement("div", {
    className: "title uk-text uk-text-knockout uk-margin-small-bottom uk-text-uppercase ".concat(classes.title)
  }, title), subtitle && /*#__PURE__*/React.createElement("div", {
    className: "subtitle uk-text-small ".concat(classes.subtitle)
  }, subtitle)), link && /*#__PURE__*/React.createElement("div", {
    className: "link uk-margin-auto-left ".concat(classes.link)
  }, /*#__PURE__*/React.createElement(Icon, {
    color: "black",
    name: "icon-arrow-right"
  })));
};
export default Banner;